var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.validationStatus === _vm.VALIDATION.NONE
      ? _c(
          "div",
          [
            _c(
              "Button2",
              {
                staticClass: "btn-sm btn-info",
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.callForValidation()
                  },
                },
              },
              [
                this.channel.type !== _vm.CHANNEL_TYPE.EMAIL
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("watchmen.validation.validate")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                this.channel.type === _vm.CHANNEL_TYPE.EMAIL
                  ? _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("watchmen.validation.validate_email")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.validationStatus === _vm.VALIDATION.WAITING
      ? _c("div", [
          _c(
            "span",
            { staticClass: "d-inline-flex align-items-center text-secondary" },
            [
              this.channel.type === _vm.CHANNEL_TYPE.PHONE
                ? _c("span", {
                    staticClass: "spinner-grow spinner-grow-sm mr-2",
                    attrs: { role: "status" },
                  })
                : _vm._e(),
              _vm._v(" "),
              this.channel.type === _vm.CHANNEL_TYPE.PHONE
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("watchmen.validation.waiting")) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.channel.type === _vm.CHANNEL_TYPE.MOBILE
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("watchmen.validation.waiting_mobile")) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              this.channel.type === _vm.CHANNEL_TYPE.EMAIL
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("watchmen.validation.waiting_email")) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validationStatus === _vm.VALIDATION.VALIDATED
      ? _c("div", [
          _c("span", { staticClass: "badge-success p-1 px-2" }, [
            _c("i", { staticClass: "fa fa-check mr-1" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("watchmen.validation.validated")) +
                "\n    "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validationStatus === _vm.VALIDATION.NO_ANSWER
      ? _c("div", [
          _c(
            "span",
            { staticClass: "d-inline-flex align-items-center text-secondary" },
            [
              _c("span", { staticClass: "text-danger" }, [
                _c("i", {
                  staticClass: "fa fa-exclamation-triangle mr-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("watchmen.validation.no_answer")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "Button2",
                {
                  staticClass: "btn-sm btn-info ml-2",
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.callForValidation()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-repeat",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("watchmen.validation.retry"))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validationStatus === _vm.VALIDATION.FAILED
      ? _c("div", [
          _c(
            "span",
            { staticClass: "d-inline-flex align-items-center text-secondary" },
            [
              _c("span", { staticClass: "text-danger" }, [
                _c("i", {
                  staticClass: "fa fa-exclamation-triangle mr-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("watchmen.validation.failed")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "Button2",
                {
                  staticClass: "btn-sm btn-info ml-2",
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.callForValidation()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-repeat",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("watchmen.validation.retry"))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validationStatus === _vm.VALIDATION.SENT
      ? _c("div", [
          this.channel.type === _vm.CHANNEL_TYPE.MOBILE
            ? _c("span", { staticClass: "text-secondary" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("watchmen.validation.sent_mobile")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          this.channel.type === _vm.CHANNEL_TYPE.EMAIL
            ? _c("span", { staticClass: "text-secondary" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("watchmen.validation.sent_email")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.validationStatus === _vm.VALIDATION.EXPIRED
      ? _c("div", [
          _c(
            "span",
            { staticClass: "d-inline-flex align-items-center text-secondary" },
            [
              _c("span", { staticClass: "text-danger" }, [
                _c("i", {
                  staticClass: "fa fa-exclamation-triangle mr-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("watchmen.validation.expired")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "Button2",
                {
                  staticClass: "btn-sm btn-info ml-2",
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.callForValidation()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-repeat",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("watchmen.validation.retry"))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }